// extracted by mini-css-extract-plugin
export default {"sale":"Sale_sale__4e0t8"};